import * as React from "react";
import { cn } from "@/lib/utils";

const R_PATH_D =
	"M 901.777 497.477 C 970.874 498.149 1040.32 496.109 1109.47 496.921 C 1172.11 497.656 1242.56 490.79 1298.82 523.061 C 1342.48 548.104 1371.67 593.196 1383.85 641.905 C 1405.57 728.813 1405.55 834.511 1362.13 914.992 C 1335.82 961.831 1290.2 993.401 1241.23 1011.56 C 1227.26 1016.74 1214.18 1022.57 1199.55 1026.49 C 1203.04 1031.54 1207.27 1035.76 1211.32 1040.39 C 1255.02 1090.3 1298.36 1140.65 1342.19 1190.45 L 1392.48 1247.81 C 1400.3 1256.69 1422.91 1277.68 1422.12 1290.5 C 1421.74 1296.79 1408.54 1299.62 1402.87 1299.78 C 1378.3 1300.44 1353.51 1299.91 1328.85 1299.94 C 1303.82 1300.03 1278.8 1299.99 1253.78 1299.82 C 1237.05 1299.66 1218.32 1300.02 1201.97 1296.84 C 1194.42 1295.37 1191.41 1291.82 1186.33 1285.86 C 1166.19 1262.27 1146.56 1237.74 1127.03 1213.64 L 1018.13 1079.44 L 949.644 995.172 C 943.726 987.997 904.865 943.826 906.839 936.769 C 918.456 930.02 948.078 923.709 962.709 919.651 C 989.277 912.241 1015.79 904.639 1042.25 896.845 C 1081.36 887.431 1148.39 864.607 1177.48 837.033 C 1199.33 816.289 1209.08 792.263 1210.07 762.521 C 1212.1 701.516 1188.68 707.963 1140.29 707.951 L 1074.44 707.977 L 865.152 708.011 L 865.29 1089.48 L 865.349 1208.71 C 865.39 1228.35 865.749 1248.21 865.456 1267.66 C 865.239 1282.06 859.626 1288.21 847.668 1294.55 C 833.561 1302.03 818.537 1309.03 804.211 1315.95 C 777.597 1328.94 750.881 1341.72 724.067 1354.28 C 704.183 1363.66 683.727 1375.2 663.035 1381.62 C 649.739 1385.75 635.16 1377.58 634.45 1363.45 C 633.365 1341.85 633.891 1319.27 633.887 1297.66 L 633.793 1154.57 L 632.384 885.084 C 631.87 828.732 631.487 772.358 631.333 716.012 C 631.289 699.687 638.56 693.328 654.401 691.386 C 671.958 689.064 689.907 690.483 707.528 689.907 C 743.279 688.737 781.027 690.514 816.538 687.636 C 819.617 685.486 822.563 682.608 825.359 680.054 C 831.682 660.78 827.962 573.453 828.038 547.297 C 828.223 483.162 835.364 498.997 901.777 497.477 z";

export interface LogoIconProps extends React.SVGAttributes<SVGSVGElement> {
	title?: string;
	animateDraw?: boolean;
	bare?: boolean;
}

export const LogoIcon = React.forwardRef<SVGSVGElement, LogoIconProps>(
	(
		{ className, title = "AgentReacher", animateDraw = false, bare = false, ...props },
		ref,
	) => {
		const glyphColor = bare ? "currentColor" : "#FFFFFF";
		return (
			<svg
				ref={ref}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 2048 2048"
				width="32"
				height="32"
				role="img"
				aria-label={title}
				className={cn("shrink-0", className)}
				{...props}
			>
				{bare ? null : <rect width="2048" height="2048" rx="460" fill="#2563EB" />}
				<g transform="translate(1024 1024) scale(1.3) translate(-1026.5 -939)">
					<path
						d={R_PATH_D}
						fill={glyphColor}
						className={animateDraw ? "logo-r-fill" : undefined}
					/>
					{animateDraw ? (
						<path
							d={R_PATH_D}
							fill="none"
							stroke={glyphColor}
							strokeWidth={30}
							strokeLinejoin="round"
							strokeLinecap="round"
							pathLength={1}
							className="logo-r-trace"
						/>
					) : null}
				</g>
			</svg>
		);
	},
);
LogoIcon.displayName = "LogoIcon";
